import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { type ReactNode, useEffect, useState } from "react";
import { useProfile } from "@/store";

// One QueryClient for the app. Server reads go through useQuery at the call
// sites (the api seam stays `api.<entity>.<method>()`); cart/wishlist/profile
// keep their zustand stores — those are session/client state that happens to
// round-trip through the server, not cached server reads.
export function QueryProvider(t0) {
  const $ = _c(6);
  const {
    children
  } = t0;
  const [queryClient] = useState(_temp);
  let t1;
  let t2;
  if ($[0] !== queryClient) {
    t1 = () => useProfile.subscribe((state, prev) => {
      if (prev.token && !state.token) {
        queryClient.clear();
      }
    });
    t2 = [queryClient];
    $[0] = queryClient;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== children || $[4] !== queryClient) {
    t3 = <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
    $[3] = children;
    $[4] = queryClient;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 300000,
        retry: 1
      }
    }
  });
}